"use client";
import {
  HEAD_TO_HEAD_LINE_FILTER_APPLIED,
  HEAD_TO_HEAD_STATUS_MAP,
} from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import { ToggleButton, ToggleSwitch } from "../ToggleSwitch";
import { TeamDisplay } from "./LineMovement";

interface TeamsControlProps {
  show: TeamDisplay;
  setShow: (show: TeamDisplay) => void;
  isMobile: boolean;
  homeShortName: string;
  homeName: string;
  awayShortName: string;
  awayName: string;
}

const TeamsControl = ({
  show,
  setShow,
  awayName,
  awayShortName,
  homeName,
  homeShortName,
  isMobile,
}: TeamsControlProps) => {
  const formattedHomeName = isMobile ? homeShortName : homeName;
  const formattedAwayName = isMobile ? awayShortName : awayName;
  const bothLabel = isMobile ? "Both" : "Both Teams";
  const { logAmplitudeEvent } = useAmplitude();
  const { eventName, gameState } = useHeadToHeadContext();
  const handleClick = (team: TeamDisplay) => {
    setShow(team);
    logAmplitudeEvent(HEAD_TO_HEAD_LINE_FILTER_APPLIED, {
      "Filter Name": "team",
      "Filter Value": team,
      Module: "line_movement",
      "Event Name": eventName,
      "Page State": HEAD_TO_HEAD_STATUS_MAP[gameState],
    });
  };
  return (
    <ToggleSwitch>
      <ToggleButton
        label={formattedAwayName}
        isActive={show === TeamDisplay.Away}
        onClick={() => handleClick(TeamDisplay.Away)}
      />
      <ToggleButton
        label={formattedHomeName}
        isActive={show === TeamDisplay.Home}
        onClick={() => handleClick(TeamDisplay.Home)}
      />
      <ToggleButton
        label={bothLabel}
        isActive={show === TeamDisplay.Both}
        onClick={() => handleClick(TeamDisplay.Both)}
      />
    </ToggleSwitch>
  );
};

export default TeamsControl;
